import React from 'react'
import Map from '../Map'

const FormDireccion = ({
  setSelectedAddress,
  setDireccion,
  handleMetodoEntrega,
  isModalScreen,
  defaultValues,
  onClose,
  showHeader,
  customerId,
  setIsErrorAddressModal,
  setMessageAddressModal,
}) => {
  return (
    <Map
      setSelectedAddress={setSelectedAddress}
      setDireccion={setDireccion}
      handleMetodoEntrega={handleMetodoEntrega}
      isModalScreen={isModalScreen}
      defaultValues={defaultValues}
      onClose={onClose}
      showHeader={showHeader}
      customerId={customerId}
      setIsErrorAddressModal={setIsErrorAddressModal}
      setMessageAddressModal={setMessageAddressModal}
    />
  )
}

export default FormDireccion
